import { AbstractStorage } from './abstract-storage.interface';

/**
 * Session Storage
 *
 * @see https://developer.mozilla.org/ru/docs/Web/API/Window/sessionStorage
 */
export abstract class SessionStorage extends AbstractStorage {}
